export const MILLIONAIRES_CONNECT_EXTERNAL_ENROLL_URL =
  'https://www.drtichglobal.com/events/register/millionaires-connect-season-7';

export const millionairesConnectAdmissionCodes = [
  'MC7-8PCD-VXLK',
  'MC7-JAAK-RDKS',
  'MC7-NVS2-WTSD',
  'MC7-BAUH-8Q4R',
  'MC7-APPS-S62H',
  'MC7-DXEV-GHXU',
  'MC7-X8L9-CFYX',
  'MC7-JK4V-CZUD',
  'MC7-EA6P-CLP7',
  'MC7-P2HE-3RKM',
  'MC7-3ZTP-GS4P',
  'MC7-MDMV-FGB6',
  'MC7-TQPM-U7WW',
  'MC7-5Q9B-EEUN',
  'MC7-BHFV-NXNP',
  'MC7-7A4R-XZ93',
  'MC7-9QGA-E24G',
  'MC7-F352-5QDX',
  'MC7-PHED-6DCB',
  'MC7-T6JB-QTXE',
  'MC7-BXZG-4QSA',
  'MC7-X7FJ-B52Q',
  'MC7-UDNV-EXX4',
  'MC7-V4U6-RKLQ',
  'MC7-WX8P-4QWC',
  'MC7-RQ2P-ZJ78',
  'MC7-E9FR-PG2S',
  'MC7-6K9E-6DFZ',
  'MC7-P5D7-6BM8',
  'MC7-D2H6-MLXH',
  'MC7-W448-WG3D',
  'MC7-AHWF-VYN7',
  'MC7-C9A8-7M23',
  'MC7-U7G5-S4KQ',
  'MC7-94EK-EDBG',
  'MC7-4SCF-BC9N',
  'MC7-MYWD-BS8K',
  'MC7-XU73-5KNM',
  'MC7-D4VK-5GHD',
  'MC7-TSKE-TRDV',
  'MC7-SP36-A6JJ',
  'MC7-THPX-Q25N',
  'MC7-A5GC-64B9',
  'MC7-ANXV-SRVU',
  'MC7-YKVS-5AZZ',
  'MC7-W6NA-6XXW',
  'MC7-HZVK-986N',
  'MC7-98BP-8B2C',
  'MC7-Z3GG-K8EF',
  'MC7-9N4S-BWXH',
  'MC7-99J4-TB77',
  'MC7-8XUW-CFQU',
  'MC7-LXV7-N8CF',
  'MC7-Z6WL-QBND',
  'MC7-AAGU-HG2D',
  'MC7-T495-ZWBS',
  'MC7-96W3-HEGK',
  'MC7-EV99-LXLE',
  'MC7-6ZMG-KWTZ',
  'MC7-HKXJ-UA8N',
  'MC7-XLVK-TDZV',
  'MC7-DZKW-PRYS',
  'MC7-AZM2-8YKR',
  'MC7-VQPQ-YNBS',
  'MC7-QNVY-VFZ5',
  'MC7-2CKC-SBT9',
  'MC7-HLJG-5FTY',
  'MC7-6QN5-4QRX',
  'MC7-V6G2-N9HC',
  'MC7-QKXP-8KNY',
  'MC7-PAHR-664J',
  'MC7-TA2Z-93UD',
  'MC7-SFZ3-2BBM',
  'MC7-R9DJ-P2MB',
  'MC7-S3H6-558T',
  'MC7-84VU-2539',
  'MC7-GVXD-K96H',
  'MC7-9DEV-NENS',
  'MC7-UXXU-ZTCK',
  'MC7-S666-U4JR',
  'MC7-5ZLQ-UK2S',
  'MC7-CH8B-UAFE',
  'MC7-SEMP-KGVH',
  'MC7-C9BM-S4FX',
  'MC7-8682-GETG',
  'MC7-4G73-7MY2',
  'MC7-TVK2-WCNV',
  'MC7-92SV-4Y3S',
  'MC7-6MZ7-P5HP',
  'MC7-FDX3-F7K8',
  'MC7-7RSB-42UK',
  'MC7-QVQA-HZB2',
  'MC7-BBQ5-QWWR',
  'MC7-EUEN-7QJA',
  'MC7-L6MX-A7RB',
  'MC7-LL3H-LTWR',
  'MC7-H5CR-DRYJ',
  'MC7-4Z97-S2LY',
  'MC7-TJUW-5BK4',
  'MC7-BG6C-WB6P',
  'MC7-C8SA-6PK4',
  'MC7-9R9W-VB26',
  'MC7-FCRZ-UJ2G',
  'MC7-SHVL-BSWM',
  'MC7-7MML-EVJH',
  'MC7-35CX-XH9H',
  'MC7-E2X4-TR7N',
  'MC7-CXD3-A8WS',
  'MC7-WESU-JQUK',
  'MC7-S88B-K7CF',
  'MC7-XZSG-9MPE',
  'MC7-8DZR-BK5X',
  'MC7-AN2C-W7N6',
  'MC7-U69P-LUKV',
  'MC7-2CCS-SZMV',
  'MC7-CTBH-VNUN',
  'MC7-TN97-MQ9H',
  'MC7-J458-DLEF',
  'MC7-F55Y-3ERU',
  'MC7-RNGF-42XL',
  'MC7-H4UG-8Y8F',
  'MC7-842C-KNFU',
  'MC7-QZX6-TV95',
  'MC7-7LL7-N5KE',
  'MC7-SPYT-BFQL',
  'MC7-YS8K-3YZF',
  'MC7-LMSD-XQ6H',
  'MC7-K4TM-DCCL',
  'MC7-YUA2-SDGS',
  'MC7-A3BM-429R',
  'MC7-CHNN-DLVK',
  'MC7-RJAB-Q27L',
  'MC7-2WNC-DTVN',
  'MC7-JHD7-FZYR',
  'MC7-JV28-6SR6',
  'MC7-R5JU-DNA7',
  'MC7-LJR4-SEZY',
  'MC7-WA8J-P5R7',
  'MC7-EBSR-L34V',
  'MC7-HFEQ-D6BB',
  'MC7-6NNL-YTLP',
  'MC7-XCT2-K6MU',
  'MC7-V84Z-CU9J',
  'MC7-6DXL-Y785',
  'MC7-L2HF-MWKS',
  'MC7-ASPQ-A85V',
  'MC7-FH8A-FVE4',
  'MC7-4L3G-KDFL',
  'MC7-U8QX-L6FC',
  'MC7-R69H-V2UD',
  'MC7-FMFQ-V54R',
  'MC7-HQBD-UY2C',
  'MC7-KVCU-YRQW',
  'MC7-KDYC-SC7Z',
  'MC7-3QMW-39LE',
  'MC7-YDDV-YB98',
  'MC7-WZ8R-QX47',
  'MC7-93YB-LGU8',
  'MC7-WPFV-4ASS',
  'MC7-ZECQ-M7PN',
  'MC7-X9YA-H64V',
  'MC7-URYM-K8HM',
  'MC7-HEEW-5JFY',
  'MC7-JQ4A-7HW7',
  'MC7-VBUZ-FUH3',
  'MC7-ZJDJ-YH2H',
  'MC7-KECD-AEAQ',
  'MC7-4MCN-Y3NJ',
  'MC7-H499-DTJG',
  'MC7-U6XB-RUQB',
  'MC7-HQDF-96DU',
  'MC7-FH5Y-MDNM',
  'MC7-LY9Z-4M8L',
  'MC7-WU8Y-YT95',
  'MC7-5BVD-NT2Z',
  'MC7-RQ9Z-6NAT',
  'MC7-H57Z-6PA7',
  'MC7-X7QX-DMWY',
  'MC7-3REL-N63B',
  'MC7-4NG6-8SMH',
  'MC7-5V8F-QJZ5',
  'MC7-TNJS-XG67',
  'MC7-JM9K-PBRW',
  'MC7-R6JP-BTDB',
  'MC7-TU7D-59HG',
  'MC7-WXE7-T44T',
  'MC7-YG27-8MRB',
  'MC7-V7NR-GE3Z',
  'MC7-K4SQ-YJJ8',
  'MC7-7UM9-9TKW',
  'MC7-R4AV-E97M',
  'MC7-D8D8-GFMU',
  'MC7-XA3S-QRSY',
  'MC7-49AZ-529J',
  'MC7-R6DN-KWLK',
  'MC7-7GQD-C4LG',
  'MC7-ZSNS-TRNX',
  'MC7-B3CS-YSTG',
  'MC7-ZTDG-96T3',
  'MC7-EJAR-CG2U'
];

export const normalizeAdmissionCode = (value = '') =>
  String(value).trim().toUpperCase().replace(/\s+/g, '');

export const millionairesConnectAdmissionCodeSet = new Set(
  millionairesConnectAdmissionCodes.map(normalizeAdmissionCode)
);

export const isValidMillionairesConnectAdmissionCode = (value = '') =>
  millionairesConnectAdmissionCodeSet.has(normalizeAdmissionCode(value));
